<template>
  <!--  <el-container class="mainWrapper">-->
  <!--&lt;!&ndash;    <div style="width:100%;height:100%; background-color: #2D2D2D;">&ndash;&gt;-->
  <!--      <el-header style="display: flex; flex-direction: column; background-color: #ffffff; margin-bottom: 20px">-->
  <!--        <top-nav v-bind:gray="gray"></top-nav>-->
  <!--      </el-header>-->

  <!--      <div class="create-account-section">-->
  <!--        <img-->
  <!--          class="create-account-background"-->
  <!--          loading="lazy"-->
  <!--          src="../../../static/img/u-connect-login-banner.jpg"/>-->
  <!--        <el-row>-->
  <!--          <h1 class="titel-text">Welcome to UNIFI</h1>-->
  <!--        </el-row>-->
  <!--        <el-row>-->
  <!--          <h2 class="sub-text">Collaborate, Grow, and Expand Your Real Estate Stock List Today</h2>-->
  <!--        </el-row>-->
  <!--        <el-row  style="display: flex; justify-content: center; align-items: center; padding-top: 20px">-->
  <!--          <p class="sub-paragraph">Log in to access the innovative B2B platform that connects real estate professionals to exclusive off-the-plan and new-build properties. UNIFI empowers you to collaborate with a network of industry experts, unlock unique revenue streams, and grow your national real estate stock list.</p>-->
  <!--        </el-row>-->

  <!--        <div class="sign-in-outer-wrapper">-->

  <!--          <el-row :gutter="20" class="sign-in-inner-wrapper" >-->
  <!--            <el-col :span="24" class="sign-in-title-wrapper">-->
  <!--              <span class="sign-in-title">Sign In</span>-->
  <!--            </el-col>-->
  <!--            <el-col :span="24" class="sign-in-form-wrapper">-->

  <!--              <el-form class="sign-in-form">-->
  <!--                <el-row class="sign-in-form-row">-->
  <!--                  <div>-->
  <!--                    <el-row :gutter="20" style="padding: 0 0 10px 0">-->
  <!--                      <div style="display: flex; align-items: center;">-->
  <!--                        <el-col :span="10">-->
  <!--                          <div  style="display: flex; align-items: center; flex-direction: row ;">-->
  <!--                            <label class="sign-up-lbl">Email Address</label>-->
  <!--                            <el-divider class="sign-in-form-divider" direction="vertical"></el-divider>-->
  <!--                            <el-input-->
  <!--                              class="sign-in-input"-->
  <!--                              v-model="email"-->
  <!--                              placeholder="Email Address"-->
  <!--                              style="width: 80%;"-->
  <!--                            >-->
  <!--                            </el-input>-->
  <!--                          </div>-->
  <!--                        </el-col>-->
  <!--                        <el-col :span="10">-->
  <!--                          <div style="display: flex; align-items: center; flex-direction: row ;">-->
  <!--                            <label class="sign-up-lbl">Password</label>-->
  <!--                            <el-divider class="sign-in-form-divider" direction="vertical"></el-divider>-->
  <!--                            <el-input-->
  <!--                              class="sign-in-input"-->
  <!--                              id="passwordfield"-->
  <!--                              v-model="Password"-->
  <!--                              v-bind:type="viewPassword?'text':'password'"-->
  <!--                              @keyup.enter.native="login"-->
  <!--                              placeholder="Password"-->
  <!--                            >-->
  <!--                            </el-input>-->
  <!--                            <el-divider class="sign-in-form-divider" direction="vertical"></el-divider>-->
  <!--                          </div>-->
  <!--                        </el-col>-->
  <!--                        <el-col :span="1">-->
  <!--                          <div style="display: flex; align-items: center; flex-direction: row ;">-->

  <!--                            <template v-if="viewPassword">-->
  <!--                              <i-->
  <!--                                class="el-icon-view"-->
  <!--                                @click="viewPassword = !viewPassword"-->
  <!--                              />-->
  <!--                            </template>-->
  <!--                            <template v-if="!viewPassword">-->
  <!--                              <i>-->
  <!--                                <img-->
  <!--                                  class="icon-hide"-->
  <!--                                  src="./../../../static/img/el-icon-hide.svg"-->
  <!--                                  @click="viewPassword = !viewPassword"-->
  <!--                                />-->
  <!--                              </i>-->
  <!--                            </template>-->
  <!--                          </div>-->
  <!--                        </el-col>-->
  <!--                        <el-col :span="3">-->
  <!--                          <div>-->
  <!--                            <el-button @click="login" class="primary-btn">Login</el-button>-->
  <!--                          </div>-->
  <!--                        </el-col>-->

  <!--                      </div>-->
  <!--                    </el-row>-->

  <!--                  </div>-->
  <!--                </el-row>-->
  <!--              </el-form>-->

  <!--            </el-col>-->
  <!--          </el-row>-->
  <!--          <el-row  :gutter="20" class="forgot-password-wrapper">-->
  <!--            <el-col :span="6" :offset="18" >-->
  <!--               <span>-->
  <!--                 <el-button class="btn-underline"-->
  <!--                            @click="dialogVisible = true"-->
  <!--                            type="text"-->
  <!--                 >Forgot password?</el-button>-->
  <!--               </span>-->

  <!--              <el-dialog-->
  <!--                class="forgotPasswordDialog"-->
  <!--                title="Forgot password"-->
  <!--                :visible.sync="dialogVisible"-->
  <!--                width="30%"-->
  <!--                :before-close="handleClose">-->
  <!--                <span class="forgotPasswordSpan">Provide your account email address to receive an email to reset your password.</span>-->

  <!--                <el-input class="forgotPasswordInput" v-model="email" placeholder="Email Address">-->
  <!--                  <template slot="prepend"><i class="el-icon-edit-outline"/></template>-->
  <!--                </el-input>-->
  <!--                <span slot="footer" class="dialog-footer forgotPasswordInputSpanBtn">-->
  <!--                  <el-button class="forgotPasswordBtn" type="primary" @click=forget>Submit</el-button>-->
  <!--                </span>-->
  <!--              </el-dialog>-->
  <!--            </el-col>-->

  <!--          </el-row>-->
  <!--          <el-row :gutter="20" class="sign-up-outer-wrapper">-->
  <!--            <el-col :span="24" style="padding: 14px 0">-->
  <!--              <el-row  class="sign-up-divider-outer-wrapper">-->
  <!--                <el-col :span="11" class="sign-up-divider-wrapper">-->
  <!--                  <div class="divider-start"></div>-->
  <!--                </el-col>-->
  <!--                <el-col :span="2" class="sign-up-divider-wrapper">-->
  <!--                  <div class="divider-mid">OR</div>-->
  <!--                </el-col>-->
  <!--                <el-col :span="11" class="sign-up-divider-wrapper">-->
  <!--                  <div class="divider-end"></div>-->
  <!--                </el-col>-->
  <!--              </el-row>-->
  <!--            </el-col>-->
  <!--            <el-col :span="24">-->
  <!--              <el-row-->
  <!--                :gutter="20"-->
  <!--                style="display: flex;align-items: flex-end; width: 100%"-->
  <!--              >-->
  <!--                <el-col-->
  <!--                 :offset="2" :span="4"-->
  <!--                  style="padding-bottom: 16px; display: flex; justify-content: flex-end;"-->
  <!--                >-->
  <!--                  <span class="sign-up-lbl font400">New to UNIFI?</span>-->
  <!--                </el-col>-->
  <!--                <el-col-->
  <!--                   :span="2"-->
  <!--                  style="padding-bottom: 14px; display: flex; justify-items: flex-end"-->
  <!--                >-->
  <!--                  <el-button-->
  <!--                    class="btn-underline"-->
  <!--                    type="text"-->
  <!--                    @click="redirectToRegistration"-->
  <!--                  >Register Now-->
  <!--                  </el-button>-->

  <!--                </el-col>-->
  <!--                <el-col :span="16"      style="padding-bottom: 16px; display: flex; justify-items: flex-start" >-->
  <!--                    <span class="sign-up-lbl font400">-->
  <!--                     and discover how our professional network can help you drive success, close more deals, and expand your reach.-->
  <!--                  </span>-->
  <!--                </el-col>-->
  <!--              </el-row>-->
  <!--            </el-col>-->
  <!--            <el-col :span="24" style="padding: 14px 0 ; display:flex; justify-content: right">-->
  <!--              <span class="contact-us font400">Need assistance? Contact us at <a target="_blank" v-bind:href="'mailto:' + contactEmail" class="contact-us-email font400">{{contactEmail}}</a></span>-->
  <!--            </el-col>-->
  <!--          </el-row>-->
  <!--          <el-row>-->


  <!--          </el-row>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--      <agent-sign-in/>-->
  <!--      <agent-sign-in-box/>-->
  <!--      <mobile-app-download/>-->
  <!--      <email-us-section-dark/>-->
  <!--      <foot-nav :isUConnectSignIn="true" />-->
  <!--&lt;!&ndash;    </div>&ndash;&gt;-->
  <!--  </el-container>-->


  <el-container :lg="3" :md="4" :sm="6" :xl="1" :xs="8" id="top" class="mainWrapper">
    <!-- Navigation Bar -->
    <el-header style="padding: 0">
      <div>
        <div
          :style="{ top: '0px', position: pos }"
          class="navWrap"
          style="display: flex"
        >
          <div class="navCon clear">
            <el-row style="display: flex; align-items: center">
              <el-col :span="5" :offset="1">
                <div class="logo" @click="redirectToHome"></div>
              </el-col>
              <el-col :span="19" style="display: flex; justify-content: flex-end">
                <el-menu
                  :default-active="activeIndex"
                  class="el-menu-demo"
                  mode="horizontal"
                  background-color="transparent"
                  @select="handleNavigation"
                  text-color="#ffffff"
                  active-text-color="#409EFF">
                  <!--          <el-menu-item index="developer">Developers</el-menu-item>-->
                  <!--          <el-menu-item index="agent">Agents</el-menu-item>-->
                  <el-menu-item index="blog">Blog</el-menu-item>
                  <el-menu-item index="developer-agent">Developers & Agents</el-menu-item>
                  <el-menu-item index="b2b">Channel Partners</el-menu-item>
                </el-menu>
                <div class="action-buttons lm-20 rp-20">
                  <!--              <el-button type="text" plain class="login-menu-btn">Login</el-button>-->
                  <el-button plain class="start-free-btn" @click="redirectToRegistration">Start Now</el-button>
                  <el-button type="primary" class="contact-sales-btn" @click="contactUs">Contact</el-button>
                </div>
              </el-col>
            </el-row>

          </div>
        </div>
        <request-to-join-u-connect-corporate-dialog v-if="requestToJoinDialogVisible"
                                                    :request-to-join-dialog-visible="requestToJoinDialogVisible"
                                                    @onClose="requestToJoinDialogVisible = false"/>
      </div>
    </el-header>

    <!-- Main Content -->
    <el-main class="login-container">
      <div class="login-box">
        <img src="../../assets/unifi-logo-new.svg" alt="login-logo" class="login-logo">
        <h2 class="welcome-text">Welcome back!</h2>
        <p class="sub-text">Let's unlock your revenue stream today</p>

        <el-form ref="loginForm" class="login-form" :model="loginForm" :rules="loginFormRules">
          <el-form-item prop="email">
            <el-input
              v-model="loginForm.email"
              placeholder="Username">
            </el-input>
          </el-form-item>

          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              placeholder="Password"
              type="password">
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              class="login-btn"
              @click="login( false)">
              Log In
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button class="developer-login" @click="login( true)">Developer/Agent Log In</el-button>

          </el-form-item>
          <el-button type="text" @click="dialogVisible = true" class="forgot-password-link">Forgot password?</el-button>
        </el-form>

        <div class="login-footer">
          <!--            <a  @click="dialogVisible = true" class="signup-link">forgot password?</a>-->
          <p class="signup-text">Don't have a profile?
            <el-button type="text" class="signup-link" @click="redirectToRegistration">Sign up now!</el-button>
          </p>

        </div>
        <!--Forgot password Dialog-->
        <el-dialog
          class="forgotPasswordDialog"
          title="Forgot password"
          :visible.sync="dialogVisible"
          width="30%"
          :before-close="handleClose">
          <span class="forgotPasswordSpan">Provide your account email address to receive an email to reset your password.</span>

          <el-input class="forgotPasswordInput" v-model="email" placeholder="Email Address">
            <template slot="prepend"><i class="el-icon-edit-outline"/></template>
          </el-input>
          <span slot="footer" class="dialog-footer forgotPasswordInputSpanBtn">
                      <el-button class="forgotPasswordBtn" type="primary" @click=forget>Submit</el-button>
                    </span>
        </el-dialog>
      </div>
    </el-main>
  </el-container>
</template>


<script>
import AgentSignIn from "../package/agentSignIn.vue";
// this is not a foolproof solution, and some browsers or browser settings may still allow users to navigate back
/*history.pushState(null, null, document.URL);
window.addEventListener('popstate', function () {
  history.pushState(null, null, document.URL);
});*/
import topNav from '@/components/package/topNav'
import footNav from '@/components/package/footer'
import {mapActions, mapMutations, mapGetters} from 'vuex'
import AgentSignInBox from "../package/agentSignInBox.vue";
// import MobileAppDownload from "../package/mobileAppDownload.vue";
import ContactUsSection from "../contact/contactUsSection.vue";
import EmailUsSectionDark from "../contact/emailUsSectionDark.vue";
import {setUserDetails} from "../../untils/authTokenUtils";
import requestToJoinUConnectCorporateDialog from "../common/requestToJoinDialog.vue";

export default {
  data() {
    return {
      contactEmail: "support@unifiproperty.com",
      activeIndex: "login",
      gray: false,
      requestToJoinDialogVisible: false,
      loginForm: {
        email: '',
        password: '',
      },
      // loginFormRules: {
      //   email: {
      //     required: true,
      //     message: "Please enter Username",
      //     trigger: "blur",
      //   },
      //   password: {
      //     required: true,
      //     message: "Please enter Password",
      //     trigger: "blur",
      //   }
      // },
      img2: '',
      email: '',
      password: '',
      viewPassword: false,
      captcha: '',
      checked: true,
      pat: {},
      maxs: 10,
      disabled: false,
      ispassword: false,
      isemail: false,
      iscaptch: false,
      loading: false,

      dialogVisible: false,

      math: '',
      tenant: window.location.hostname.split('.')[0].split("unifiproperty")[0].split("dashboard")[0],
    }

  },
  components: {
    topNav,
    EmailUsSectionDark,
    ContactUsSection,
    // MobileAppDownload,
    AgentSignInBox,
    AgentSignIn,
    footNav,
    requestToJoinUConnectCorporateDialog
  },
  computed: {
    ...mapGetters(['verimg'])
  },
  methods: {
    ...mapActions(['signIn', 'forgotPassword']),
    ...mapMutations(['settoken', 'setStripeId', 'setrole', 'setAccount', 'setmsg', 'setUserId', 'setRolePermission']),
    //输入email
    onemail() {
      this.isemail = !this.isemail
    },
    onpassword() {
      this.ispassword = !this.ispassword
    },
    oncaptcha() {
      this.iscaptch = !this.iscaptch
    },
    handleNavigation(key, keyPath) {
      var that = this
      switch (key) {
        case "developer-agent":
          that.redirectToAgentDeveloper();
          break;
        case "blog":
          that.redirectToBlog();
          break;
        case "b2b":
          that.redirectToRegistration();
          break;
        default:
          break;
      }
    },
    login(isAgentLogin) {

      //登录
      console.log("login")
      if (!this.loginForm.email) {
        Utils.alert('', 'Please enter Username', 'error');
        return
      }
      if (!this.loginForm.password) {
        Utils.alert('', 'Please enter Password', 'error');
        return
      }
      // else{
      //     if(this.Password.split('').length<8){
      //         Utils.alert('','The password must not be less than 8 digits','error')
      //         return
      //     }
      // }
      this.loading = true
      let pat = {}
      pat.userName = this.loginForm.email
      pat.password = this.loginForm.password
      pat.code = this.captcha
      pat.tid = this.math
      this.$http.post(`${process.env.VUE_APP_ROOT_API}/oa/admin/login`, JSON.stringify(pat)).then((resp) => {
        this.loading = false
        if (resp.body.code == 0) {

          let token = resp.body.data.token
          this.settoken(token);
          this.setrole(resp.body.data.role)
          this.setRolePermission(resp.body.data.rolePermission)
          window.sessionStorage.setItem('name', resp.body.data.name)
          localStorage.clear()
          setUserDetails(resp.body.data.token);
          localStorage.setItem("rolePermission", resp.body.data.rolePermission);
          if (isAgentLogin) {
            this.$router.replace({path:'/index' + "?" + Math.random()})
          } else {
            this.$router.replace({path: '/uconnect/search/results' + "?" + Math.random()})
          }
        } else {
          Utils.alert('', resp.body.message, 'error')
        }
      }, res => {
        this.loading = false
        Utils.alert('', 'Unable to connect to the server.', 'error');
      })
    },
    forget() {
      console.log("forget method called")
      console.log("email:   " + this.email)
      let pat = {
        email: this.email
      }
      this.forgotPassword({pat: pat, callback: this.forgotCallback})
      this.dialogVisible = false
    },
    forgotCallback(res) {
      var that = this
      console.log("forgotCallback")
      //that.$box.loadings(2)
      if (res.data.code == 0) {
        //that.haveSubmit = true
      } else {
        //that.$box.alert('', res.data.message ,'error')
      }
    },
    handleClose() {
      //this.$confirm('Are you sure to close this dialog?')
      //.then(_ => {
      //  done();
      //})
      //.catch(_ => {});
      this.dialogVisible = false
    },
    changevid() {
      this.math = Math.random()
      Utils.saveLocal('tid', this.math)
    },
    redirectToHome() {
      window.open(
        `${process.env.VUE_APP_UNIFI}#/`, "_self"
      );
    },
    redirectToRegistration() {
      // this.$router.push({path: "/uConnectRegister"});

      window.open(
        `${process.env.VUE_APP_UNIFI}#/pricing`, "_self"
      );
    },
    redirectToAgentDeveloper() {
      window.open(
        `${process.env.VUE_APP_UNIFI}#/agents`, "_self"
      );
    },
    redirectToBlog() {
      window.open(
        `${process.env.VUE_APP_UNIFI}#/blog`, "_self"
      );
    },
    contactUs() {
      this.requestToJoinDialogVisible = true;
    },
  },
  mounted() {
    //每次进入清空token信息
    this.math = Math.random()
    // Utils.saveLocal('token','')
    let err = this.$route.params.err
    if (err == 1) {
      this.centerDialogVisible1 = true
      this.centerDialogVisible = false
    } else if (err == 2) {
      this.centerDialogVisible1 = false
      this.centerDialogVisible = true
    }
  },
  watch: {
    Password(o, a) {
      if (o) {
        let arr = o.split('')
        if (arr.length > 16) {
          this.password = a
        }
      }
    },
    captcha(n, o) {
      if (n) {
        if (n.split('').length > 4) {
          this.captcha = o
        }
      }
    }
  }
}
</script>


<style scoped>
.login-page {
  font-family: 'Arial', sans-serif;
  min-height: 100vh;
  background: radial-gradient(circle at bottom right, #003030 70%, #121312 100%);
  padding : 0 20px;
}
.mainWrapper {
  background: radial-gradient(circle at bottom right, #003030 70%, #121312 100%);
  max-width: 1920px;
  margin: auto;
}
.navWrap {
  width: 100%;
  height: 104px;
  min-width: 1200px;
  position: absolute;
  left: 0;
  top: 0;
  transition: background-color 0.5s;
  z-index: 11;
  padding: 7px 0;
  background-color: transparent;
}
.navCon {
  width: 1860px;
  margin: auto auto;
  background-color: transparent;

  .logo {
    width: 300px;
    height: 50px;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    background-image: url("../../assets/unifi-logo-new-with-text-white.svg");
    float: left;
    cursor: pointer;
  }
}

.logo {
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

.el-menu-demo {
  border-bottom: none;
  color: #003333;
}

.el-menu-item {
  color: #ffffff !important;
}
.el-menu-item:hover {
  background-color: #003333;
  color: #ffffff;
}
.el-menu-item.is-active {
  border-bottom: 2px solid #ffffff !important;

}
.el-menu /deep/ .el-menu-item:hover{
  background-color: white !important;
  color: #003333 !important;
}
.el-menu--horizontal /deep/ .el-menu-item{
  height: 40px;
  line-height: 40px;
}

.login-menu-btn{
  color: #ffffff;
}
.login-menu-btn:hover, .login-menu-btn:focus {
  background-color: #003333;
  color: #ffffff;
  border-color: transparent;
}

.action-buttons {
  display: flex;
  gap: 10px;
}
.lm-20{
  margin-left: 20px;
}
.rp-20 {
  padding-right: 20px;
}
.start-free-btn {
  border-color: #ffffff;
  color: #003333;
}

.start-free-btn:hover, .start-free-btn:focus {
  background-color: #003333;
  color: #ffffff;
  border-color: #ffffff;
}
.contact-sales-btn {
  background-color: #ffffff;
  border-color: #ffffff;
  color: #003333;
}
.contact-sales-btn:hover, .contact-sales-btn:focus {
  background-color: #003333;
  color: #ffffff;
  border-color: #ffffff;
}


.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 60px);
}

.login-box {
  width: 400px;
  padding: 40px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
}

.login-logo {
  width: 10%;
  height: auto;
  margin-bottom: 20px;
}
.welcome-text {
  font-size: 34px;
  color: #003333;
  margin-bottom: 10px;
}

.sub-text {
  font-size: 13px;
  color: #003333;
  margin-bottom: 30px;
}

.login-form {
  margin-top: 20px;
}
.el-form-item {
  margin-bottom: 0;
}
.login-form /deep/ .el-input__inner {
  border-color: #003333;
  border-radius: 10px;
  height: 30px;
  line-height: 30px;
}

.login-btn {
  width: 100%;
  border-radius: 20px;
  margin-top: 10px;
  background-color: #003333;
  border-color: #003333;
  padding: 5px 12px;
}

.login-footer {
  margin-top: 20px;
  font-size: 14px;
}

.developer-login {
  width: 100%;
  color: #ffffff;
  background-color: #003333;
  border-color: #003333;
  padding: 5px 12px;
  border-radius: 20px;
  margin-bottom: 40px;
}

.signup-text {
  color: #666;
}
.forgot-password-link {
  color: #003333;
  font-weight: 600;
  text-decoration: none;
  font-size: 14px;
}
.signup-link {
  color: #003333;
  font-weight: 600;
  text-decoration: none;

}
.forgotPasswordDialog {
    margin-top: 290px;
}

.forgotPasswordSpan {
 padding-bottom: 10px;
}

.forgotPasswordInput {
 padding-top: 10px;
}
.forgotPasswordBtn {
      color: #ffffff;
      justify-content: center;
      white-space: normal;
      align-items: center;
      border: 3px solid #003333;
      background-color: #003333;
      width: 260px;
      font: 500 16px DINosaur-a, sans-serif;
      padding: 5px 12px;
      border-radius: 20px;
}

.forgot-password-link:hover,
.signup-link:hover {
  text-decoration: underline;
}
</style>

<!--<style lang="scss" scoped>-->
<!--.mainWrapper{-->
<!--  background-color: #ffffff;-->
<!--  max-width: 1920px;-->
<!--  margin: auto;-->
<!--}-->
<!--.create-account-section {-->
<!--  display: flex;-->
<!--  flex-direction: column;-->
<!--  justify-content: center;-->
<!--  align-items: center;-->
<!--  overflow: hidden;-->
<!--  align-self: stretch;-->
<!--  position: relative;-->
<!--  min-height: 800px;-->
<!--  width: 100%;-->
<!--  padding: 50px 60px;-->
<!--  background-color: #0d0d0d;-->
<!--}-->

<!--.create-account-background {-->
<!--  position: absolute;-->
<!--  inset: 0;-->
<!--  height: 100%;-->
<!--  width: 100%;-->
<!--  max-width: 1920px;-->
<!--  object-fit: cover;-->
<!--  object-position: 25% 75%;-->
<!--  opacity: 0.5;-->
<!--}-->
<!--.titel-text {-->
<!--  color: #ffffff;-->
<!--  font-feature-settings: "clig" off, "liga" off;-->
<!--  font: 600 40px DINosaur-a, sans-serif;-->
<!--}-->
<!--.sub-text {-->
<!--  color: #ffffff;-->
<!--  font-feature-settings: "clig" off, "liga" off;-->
<!--  font: 600 30px DINosaur-a, sans-serif;-->
<!--}-->
<!--.sub-paragraph {-->
<!--  color: #ffffff;-->
<!--  font-feature-settings: "clig" off, "liga" off;-->
<!--  font: 400 20px/20px DINosaur-a, sans-serif;-->
<!--  max-width: 75%;-->
<!--}-->
<!--.sign-in-outer-wrapper {-->
<!--  position: relative;-->
<!--  align-items: center;-->
<!--  background-color: transparent;-->
<!--  display: flex;-->
<!--  width: 1900px;-->
<!--  max-width: 100%;-->
<!--  flex-direction: column;-->
<!--  justify-content: center;-->
<!--  margin: 105px 0;-->
<!--  border-radius: 15px 15px 0 0;-->
<!--}-->
<!--.sign-in-form-divider{-->
<!--  height: 2em;-->
<!--  background-color: #003333;-->
<!--}-->
<!--.sign-in-inner-wrapper {-->
<!--  min-width: 80%;-->
<!--  width: 80%;-->
<!--}-->

<!--.sign-in-title-wrapper {-->
<!--  background-color: #003333;-->
<!--  padding: 20px;-->
<!--  border-radius: 15px 15px 0 0;-->
<!--}-->
<!--.sign-in-title {-->
<!--  color: #fff;-->
<!--  font-feature-settings: "clig" off, "liga" off;-->
<!--  font: 500 30px DINosaur-a, sans-serif;-->

<!--}-->
<!--.sign-in-form-wrapper {-->
<!--  background-color: #ffffff;-->
<!--  border-radius: 0 0 15px 15px;-->
<!--}-->
<!--.sign-in-form {-->
<!--  background-color: #ffffff;-->
<!--  border-radius: 0 0 15px 15px;-->
<!--}-->
<!--.sign-in-form-row {-->
<!--  margin-left: 10px ;-->
<!--  margin-right: 10px;-->
<!--  padding: 10px;-->
<!--  margin-top: 24px;-->
<!--}-->

<!--.primary-btn {-->
<!--  color: #fff;-->
<!--  text-align: center;-->
<!--  font-feature-settings: "clig" off, "liga" off;-->
<!--  font-family: DINosaur-a;-->
<!--  font-size: 20px;-->
<!--  font-style: normal;-->
<!--  font-weight: 500;-->
<!--  line-height: normal;-->
<!--  display: flex;-->
<!--  padding: 8px 32px;-->
<!--  justify-content: center;-->
<!--  align-items: center;-->
<!--  border-radius: 5px;-->
<!--  border: 3px solid #003333;-->
<!--  background: #003333;-->
<!--}-->

<!--.sign-up-lbl {-->
<!--  color: #ffffff;-->
<!--  font-feature-settings: "clig" off, "liga" off;-->
<!--  font-family: DINosaur-a;-->
<!--  font-size: 16px;-->
<!--  font-style: normal;-->
<!--  line-height: 125%;-->
<!--}-->

<!--.forgot-password-wrapper {-->
<!--  min-width: 80%;-->
<!--  width: 80%;-->
<!--}-->
<!--.btn-underline {-->
<!--  border-bottom: 2px solid #ffffff;-->
<!--  padding-bottom: 2px;-->
<!--  margin-left: 10px;-->
<!--  border-radius: 0;-->
<!--  color: #ffffff;-->
<!--  font: 500 16px DINosaur-a, sans-serif;-->
<!--  float: right;-->
<!--}-->
<!--.sign-in-input {-->
<!--  font-family: DINosaur-a;-->
<!--  color: #003333;-->
<!--}-->
<!--.sign-in-input /deep/ .el-input__inner {-->
<!--  border: none;-->
<!--  border-radius: 0;-->
<!--  box-shadow: none;-->
<!--  color: #003333;-->
<!--  font: 400 16px DINosaur-a, sans-serif;-->
<!--}-->

<!--@media (max-width: 991px) {-->
<!--  .create-account-section {-->
<!--    max-width: 100%;-->
<!--    padding: 0 20px;-->
<!--  }-->
<!--}-->

<!--.forgotPasswordDialog {-->
<!--  margin-top: 290px;-->
<!--}-->

<!--.forgotPasswordSpan {-->
<!--  padding-bottom: 10px;-->
<!--}-->

<!--.forgotPasswordInput {-->
<!--  padding-top: 10px;-->
<!--}-->

<!--.forgotPasswordBtn {-->
<!--  color: #ffffff;-->
<!--  height: 54px;-->
<!--  justify-content: center;-->
<!--  white-space: normal;-->
<!--  align-items: center;-->
<!--  border-radius: 5px;-->
<!--  border: 3px solid #003333;-->
<!--  background-color: #003333;-->
<!--  width: 260px;-->
<!--  font: 500 20px DINosaur-a, sans-serif;-->
<!--}-->


<!--.icon-hide {-->
<!--  padding-top: 2px;-->
<!--  filter: invert(64%) sepia(13%) saturate(131%) hue-rotate(182deg) brightness(90%) contrast(87%);-->
<!--  height: 14px;-->
<!--}-->
<!--.sign-up-outer-wrapper {-->
<!--  min-width: 80%;-->
<!--  width: 80%;-->
<!--}-->

<!--.sign-up-divider-outer-wrapper {-->
<!--  width: 100%;-->
<!--  display: flex;-->
<!--  margin-top: 14px;-->
<!--  justify-content: space-between;-->
<!--  gap: 20px;-->
<!--}-->

<!--.sign-up-divider-wrapper {-->
<!--  display: flex;-->
<!--  justify-content: center;-->
<!--  align-items: center;-->
<!--}-->


<!--.divider-start {-->
<!--  background-color: #ffffff;-->
<!--  align-self: center;-->
<!--  min-width: 100%;-->
<!--  max-width: 100%;-->
<!--  height: 1px;-->
<!--  margin: auto 0;-->
<!--}-->

<!--.divider-mid {-->
<!--  color: #ffffff;-->
<!--  font-feature-settings: "clig" off, "liga" off;-->
<!--  font: 500 16px/125% DINosaur-a, sans-serif;-->
<!--}-->

<!--.divider-end {-->
<!--  background-color: #ffffff;-->
<!--  align-self: center;-->
<!--  min-width: 100%;-->
<!--  max-width: 100%;-->
<!--  height: 1px;-->
<!--  margin: auto 0;-->
<!--}-->
<!--.contact-us {-->
<!--  color: #ffffff;-->
<!--  font-feature-settings: "clig" off, "liga" off;-->
<!--  font: 400 16px DINosaur-a, sans-serif;-->
<!--  max-width: 75%;-->
<!--}-->
<!--.contact-us-email {-->
<!--  color: #ffffff;-->
<!--  font-feature-settings: "clig" off, "liga" off;-->
<!--  font: 400 16px DINosaur-a, sans-serif;-->
<!--  max-width: 75%;-->
<!--  text-decoration-line: underline;-->
<!--}-->

<!--/* Medium devices (landscape tablets, 768px and up) */-->
<!--@media only screen and (min-width: 768px) {-->

<!--}-->

<!--/* Large devices (laptops/desktops, 992px and up) */-->
<!--@media only screen and (min-width: 992px) {-->
<!--  .sign-in-outer-wrapper {-->
<!--    margin: 40px 0;-->
<!--    padding: 0 20px;-->
<!--  }-->
<!--  .sign-in-form-row {-->
<!--    margin-left: 40px ;-->
<!--    margin-right: 40px;-->
<!--  }-->
<!--  .sign-up-lbl {-->
<!--    min-width: 110px;-->
<!--  }-->
<!--}-->

<!--/* Extra large devices (large laptops and desktops, 1200px and up) */-->
<!--@media only screen and (min-width: 1200px) {-->
<!--  .sign-in-form-row {-->
<!--    margin-left: 30px ;-->
<!--    margin-right: 30px;-->
<!--  }-->
<!--  .sign-up-lbl {-->
<!--    min-width: 120px;-->
<!--  }-->
<!--}-->
<!--@media only screen and (min-width: 1400px) {-->
<!--  .sign-in-form-row {-->
<!--    margin-left: 10px;-->
<!--    margin-right: 10px;-->
<!--  }-->
<!--}-->

<!--</style>-->



// WEBPACK FOOTER //
// src/components/uConnectLogin/index.vue